import type { CtaContentProps } from './cta-content';
import CtaContent, { ctaButtonLeading, ctaButtonTextSize, ctaButtonSize } from './cta-content';

export default function CtaLink(props: CtaContentProps) {
  const { size } = props;
  const leading = ctaButtonLeading(size);
  const textSize = ctaButtonTextSize(size);
  const buttonSize = ctaButtonSize(size);
  return (
    <a
      className={`${buttonSize} ${leading} ${textSize} font-semibold text-white bg-blue-500 hover:bg-blue-700 w-full group whitespace-nowrap`}
      href="/app/signup"
    >
      <CtaContent {...props} />
    </a>
  );
}
